import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-accent-600 bg-accent-100 px-3 py-1 rounded-full">
            专题合集
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            专题合集
          </h2>
          <p className="text-sm text-foreground-600 mt-2">深度策划，一次吃到饱</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {indexData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {item.description}
                </p>
                <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2 py-1 rounded-full">
                  {item.count}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}